export enum EAppStatus {
    Online = 1,
    Offline = 2,
    Alert = 3
}